import { useQuery } from "react-query";
import { getTraumaHistory } from "api/customers";
import { GET_TRAUMA_HISTORY } from "@constants/reactQueryKeys";

const useGetTraumaHistory = (clientId: number | null) => {
  const { data, isLoading, refetch } = useQuery(
    [GET_TRAUMA_HISTORY, clientId],
    () => getTraumaHistory(clientId!),
    { enabled: Boolean(clientId) }
  );

  return {
    traumaHistory: data?.data ?? null,
    isTraumaHistoryLoading: isLoading,
    refetchTraumaHistory: refetch,
  };
};

export default useGetTraumaHistory;
